import React from "react";
import { FaStar } from "react-icons/fa";
import EnlargedImage from "../components/Image";
import Table from "../components/Table";
import useUserDetails from '../hooks/logics/user-accounts/use-user-details';
import { formatDate2 } from "../utils/helpers";

const UserDetails = () => {

  const DetailRow = ({ label, value }: { label: string; value?: string | number | null }) => (
    <div className="flex items-start gap-2">
      <p className="text-gray-500 min-w-[140px] text-sm">{label}</p>
      <p className="font-semibold text-sm text-gray-900 break-all">{value ?? "N/A"}</p>
    </div>
  );

  const {
    id,
    details,
    loading,
    image,
    zoomed,
    setZoomed,
    handleImageClick,
    approvedMap,
    createdByMap,
  } = useUserDetails();



  return (

    <div className="py-1 h-auto flex  flex-col justify-center font-inter bg-gray-100 ">
      <div className="w-full max-h-max md:h-96 bg-white rounded-lg shadow-xl ">
        {loading === true ? (
          <div className="w-full py-10 h-full flex items-center justify-center">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            <div className="flex flex-col">

              {/* Left - Profile */}
              <div className="w-full  p-4 border-b border-gray-100">
                <div className="flex flex-row items-center gap-4">
                  <img
                    onClick={() => handleImageClick(details?.profileImage!)}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png";
                    }}
                    className="w-16 h-16 md:w-20 md:h-20 object-cover border-2 border-gray-200 rounded-full md:rounded-3xl cursor-pointer flex-shrink-0"
                    src={details?.profileImage}
                    alt="profile"
                  />
                  <div className="flex flex-col md:mt-4">
                    <h2 className="text-base md:text-2xl font-semibold ">
                      {details?.fullName}
                    </h2>
                    <p className="text-sm text-gray-500 mt-0.5 md:mt-1 break-all">{details?.email}</p>
                    {details?.ratingCount !== 0 && (
                      <div className="flex items-center gap-1 mt-2">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            color={i + 1 <= details?.rating! ? "#FDCC0D" : "#e5e7eb"}
                            size={14}
                          />
                        ))}
                        <p className="ml-1 text-gray-500 text-xs">
                          ({details?.ratingCount})
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                  <DetailRow label="Joined:" value={formatDate2(details?.createdAt || "")} />
                  <DetailRow label="Phone number:" value={details?.phone} />
                  <DetailRow label="State:" value={details?.state} />
                  <DetailRow label="Total orders:" value={details?.totalOrders ?? 0} />
                  <DetailRow label="Completed orders:" value={details?.completedOrders ?? 0} />
                  <DetailRow label="Approved:" value={approvedMap[details?.isEmailVerified?.toString()!]} />
                  <DetailRow label="Created by admin:" value={createdByMap[details?.createdBy?.toString()!]} />
                </div>
              </div>

            </div>



          </>
        )}
      </div>
      <Table userId={id} />
      <EnlargedImage isVisible={zoomed} setVisible={setZoomed} src={image} />
    </div>

  );
};

export default UserDetails;
